<script setup lang="ts">
import MoneyFormatter from '../moneyFormatters/MoneyFormatter.vue';
import RelativeMoneyFormatter from '../moneyFormatters/RelativeMoneyFormatter.vue';
import TimeRangeFormatter from '../timeFormatters/TimeRangeFormatter.vue';
import TravelDurationFormatter from '../timeFormatters/TravelDurationFormatter.vue';

import { LabelFormatterType } from './LabelFormatter.model';
import type { LabelFormatterTypes } from './LabelFormatter.model';

interface LabelFormatterProps {
  data: LabelFormatterTypes;
}

const props = defineProps<LabelFormatterProps>();
// TODO: Consider adding default formater
</script>

<template>
  <template
    v-if="props.data.formatterType === LabelFormatterType.MoneyFormatter"
  >
    <MoneyFormatter :data="props.data.data" />
  </template>

  <template
    v-if="
      props.data.formatterType === LabelFormatterType.RelativeMoneyFormatter
    "
  >
    <RelativeMoneyFormatter :data="props.data.data" />
  </template>
  <template
    v-if="props.data.formatterType === LabelFormatterType.TimeRangeFormatter"
  >
    <TimeRangeFormatter :data="props.data.data" />
  </template>
  <template
    v-if="
      props.data.formatterType === LabelFormatterType.TravelDurationFormatter
    "
  >
    <TravelDurationFormatter :data="props.data.data" />
  </template>
</template>
